import { render, staticRenderFns } from "./SubscribersReport.vue?vue&type=template&id=37b27d85&"
import script from "./SubscribersReport.vue?vue&type=script&lang=js&"
export * from "./SubscribersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b27d85')) {
      api.createRecord('37b27d85', component.options)
    } else {
      api.reload('37b27d85', component.options)
    }
    module.hot.accept("./SubscribersReport.vue?vue&type=template&id=37b27d85&", function () {
      api.rerender('37b27d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/SubscribersReport.vue"
export default component.exports